import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import React from "react";

interface AlertDialogProps {
  open: boolean;
  onClose: () => void;
  confirmText?: string;
  children?: React.ReactNode;
  fullWidth?: boolean;
}

const SFAlertDialog: React.FC<AlertDialogProps> = ({
  open,
  onClose,
  confirmText = "확인",
  children,
  fullWidth,
}) => {
  return (
    <Dialog
      PaperProps={{
        sx: {
          borderRadius: 4,
          px: 3,
          py: 3.5,
          width: fullWidth ? "100%" : "auto",
        },
        elevation: 1,
      }}
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box mb={5}>{children}</Box>
      <Button size="large" fullWidth onClick={onClose} variant="contained">
        {confirmText}
      </Button>
    </Dialog>
  );
};

export default SFAlertDialog;
